export default "__VITE_ASSET__D9t5hzLe__"